import { render, staticRenderFns } from "./recognation.vue?vue&type=template&id=4607f523&"
import script from "./recognation.vue?vue&type=script&lang=js&"
export * from "./recognation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports